module.exports = __webpack_public_path__ + "img/m-feiyongbaobiao.1223633d.svg";